import { Body } from '../types.js';
import { vecNorm, vecMag } from '../utils/math.js';

// Arcady-feel body colors and properties
const BODY_THEMES: { name: string; color: string; glow: string; isStar?: boolean }[] = [
  { name: 'Fireball', color: '#ff4422', glow: '#ff660080' },
  { name: 'Ember', color: '#ffaa00', glow: '#ffcc4480' },
  { name: 'Plasma', color: '#8844ff', glow: '#aa66ff80' },
  { name: 'Nova', color: '#44ddff', glow: '#66ffee80' },
  { name: 'Quasar', color: '#ff22aa', glow: '#ff44cc80' },
  { name: 'Void', color: '#444466', glow: '#66668880' },
  { name: 'Frost', color: '#aaddff', glow: '#ccffff80' },
  { name: 'Magma', color: '#ff6600', glow: '#ff883380' },
  { name: 'Aurora', color: '#44ff88', glow: '#66ffaa80' },
  { name: 'Ion', color: '#dd44ff', glow: '#ee66ff80' },
];

let bodyCounter = 0;

export function makeArcadeBody(
  x: number, y: number,
  vx: number, vy: number,
  mass: number, radius: number,
  isStar: boolean = false
): Body {
  const theme = BODY_THEMES[bodyCounter % BODY_THEMES.length];
  bodyCounter++;

  return {
    id: bodyCounter,
    x, y,
    vx, vy,
    ax: 0, ay: 0,
    mass,
    radius,
    color: theme.color,
    glowColor: theme.glow,
    name: isStar ? 'Star' : theme.name,
    trail: [],
    maxTrail: 500,
    isStar,
  };
}

export function createSolarSystemScenario(): Body[] {
  const bodies: Body[] = [];

  // Central star
  const sun = makeArcadeBody(0, 0, 0, 0, 500, 30, true);
  sun.name = 'Sol';
  sun.color = '#ffdd00';
  sun.glowColor = '#ffee0080';
  sun.maxTrail = 0;
  bodies.push(sun);

  // Inner rocky planets
  bodies.push(makeArcadeBody(120, 0, 0, 1.8, 5, 5));
  bodies[1].name = 'Mercurius';

  bodies.push(makeArcadeBody(200, 0, 0, 1.4, 12, 8));
  bodies[2].name = 'Vulcanis';

  // Earth-like
  bodies.push(makeArcadeBody(320, 0, 0, 1.1, 25, 11));
  bodies[3].name = 'Terra';

  // Outer gas giants
  bodies.push(makeArcadeBody(500, 0, 0, 0.9, 80, 18));
  bodies[4].name = 'Jovis';

  bodies.push(makeArcadeBody(700, 0, 0, 0.7, 120, 24));
  bodies[5].name = 'Saturnus';

  // A few extras
  bodies.push(makeArcadeBody(450, 200, -0.4, 0.5, 15, 7));
  bodies[6].name = 'Wanderer';

  bodies.push(makeArcadeBody(-300, -150, 0.3, 0.8, 40, 13));
  bodies[7].name = 'Rogue';

  return bodies;
}
